import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./studentDiscounts.gql"

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    afterSubmit, uploadRef 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addStudentDiscountMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)
  const [isUploadImage, setIsUploadImage] = useState(false)
  const [addStudentDiscount, {
    data, error: addMilitaryDiscountError 
  }] =
        useMutation(addStudentDiscountMutation, {
          fetchPolicy: "no-cache",
        })

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        firstname, lastname, email 
      } = formState.values

      setIsLoading(true)
      const {
        fileList, setFileList 
      } = uploadRef.current
      let image

      if (fileList.length) {
        image = fileList[0].thumbUrl
        setIsUploadImage(false)
      } else {
        setIsLoading(false)
        setIsUploadImage(true)

        return false
      }

      try {
        await addStudentDiscount({
          variables: {
            firstname,
            lastname,
            email,
            image,
            type_id: 1,
          },
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }

        setFileList([])

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addStudentDiscount, afterSubmit, uploadRef]
  )

  const errors = useMemo(
    () => new Map([["addMilitaryDiscountError", addMilitaryDiscountError]]),
    [addMilitaryDiscountError]
  )

  return {
    formApiRef,
    isLoading,
    errors,
    handleSubmit,
    response: data && data.addDiscountInfo,
    isUploadImage,
  }
}
